import Resource from '@/services/resources/common';

export default class GeometryPointResource extends Resource {
  constructor(entrypoint = '/points', alias = 'GeometryPoint') {
    super(entrypoint, alias);
  }
}
